import { useMemo } from "react";
import { useDataContext } from "../context/DataContext";
import { timesheetCell, timesheetColumns } from "./timesheetTable.js";
import "./Styles/TimesheetsPage.css";

export default function TimesheetsPage(): JSX.Element {
  const { personnelTimeSheetRows } = useDataContext();
  const columns = useMemo(() => timesheetColumns(personnelTimeSheetRows), [personnelTimeSheetRows]);
  const count = personnelTimeSheetRows.length;

  return (
    <div className="timesheets-page">
      <h1 className="timesheets-page__title">Timesheets</h1>
      <p className="timesheets-page__count">{count} {count === 1 ? "row" : "rows"}</p>
      <div className="timesheets-page__scroll">
        <table className="timesheets-table">
          <thead>
            <tr>
              {columns.map((column) => (
                <th key={column} scope="col">{column}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {personnelTimeSheetRows.map((row, index) => (
              <tr key={index}>
                {columns.map((column) => {
                  const text = timesheetCell(row[column]);
                  return <td key={column} title={text}>{text}</td>;
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
